import { render, staticRenderFns } from "./AnalyticPerson.vue?vue&type=template&id=d6308a80"
import script from "./AnalyticPerson.vue?vue&type=script&lang=js"
export * from "./AnalyticPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports